// Links to other websites (Instagram, stockists, links inside journal posts, …) open in a
// new tab so visitors keep paracia.com open. Links within the shop stay in the same tab.
// Done on click, so it also covers links added later (menus, text from Shopify).
const isExternal = (link: HTMLAnchorElement): boolean => {
  if (!/^https?:$/.test(link.protocol)) return false; // mailto:, tel:, …
  const host = link.hostname.replace(/^www\./, '');
  const ownHost = window.location.hostname.replace(/^www\./, '');
  return host !== ownHost && !host.endsWith('paracia.com');
};

document.addEventListener(
  'click',
  (event) => {
    const link = (event.target as Element | null)?.closest?.('a[href]') as HTMLAnchorElement | null;
    if (!link || !isExternal(link) || link.target) return;

    link.target = '_blank';
    link.rel = 'noopener';
  },
  true
);
